import {Location} from '@angular/common';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatIconRegistry} from '@angular/material/icon';
import {MatSelectChange} from '@angular/material/select';
import {MatSidenav} from '@angular/material/sidenav';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, Router} from "@angular/router";
import {ConsoleUserService} from "@core-services/console-user.service";
import {GlobalSettingsComponent} from '@features/settings/global-settings/global-settings.component';
import {ConsoleAuthorizationService} from "@security/console-authorization.service";
import {ConsoleContextService} from "@security/console-context.service";
import {UtilsService} from '@shared-services/utils.service';
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {NavigationUtilsService} from "@ui-kit/framework/util/service/navigation-utils.service";
import {equalsIgnoreCase} from "projects/nter-ui-kit/src/lib/framework/util/static/string-util";
import {lastValueFrom} from 'rxjs';
import {ConfirmationDialogComponent} from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import {ThemeService} from 'src/themes/theme-service.service';
import {
  accountsItems,
  dashboardItems,
  digitalAdvertisingPageSections,
  districtPageSections,
  exhibitionPageSections,
  generalLeasingPageSections,
  kiosksPageSections,
  leasingItems,
  marketsPageSections,
  onDemandItems,
  onDemandPageSections,
  pipelineItems,
  popUpsPageSections,
  settingsItems,
  spacesItems,
  storagePageSections,
  supportItem,
  viewItems
} from "../../constants/side-nav.constants";
import {PageEventInterface} from "../../interfaces/page-event.interface";
import {UserNotificationInterface} from '../../interfaces/user-notification.interface';
import {CurrentLandlordModel} from '../../model/landlord.model';
import {LandlordPropertyModel} from '../../model/landlordProperty.model';
import {PageItemModel} from '../../model/page-item.model';
import {
  LocationOffering,
  PageOffering,
  PageSection,
  PageSectionItem,
  PageSectionItemInfo,
} from '../../model/side-nav.model';
import {LandlordsService} from '../../services/landlords.service';
import {TabManagementService} from '../../services/tab-management.service';
import {NotificationsDialogComponent} from '../notifications/notifications-dialog/notifications-dialog.component';

@Component({
  selector: 'app-home-screen',
  templateUrl: './home-screen.component.html',
  styleUrls: ['./home-screen.component.scss']
})

export class HomeScreenComponent implements OnInit, AfterViewInit {

  isPropertySelected = false;
  @ViewChild("notificationsSidenav") notificationSideNav!: MatSidenav;
  @ViewChild("sidenav") sidenav!: MatSidenav;

  loading$ = this.loader.loading$;

  selectedProperty: LandlordPropertyModel | null = null;
  properties: LandlordPropertyModel[] = [];
  pageOfferings: PageOffering[] = [];
  pageSections: PageSection[] = [];
  pageSectionItems: PageSectionItem[] = [];
  landlord!: CurrentLandlordModel;
  landlordLogo: string = '../assets/icons/default-nter-logo.svg';

  pages: PageItemModel[] = [];
  notifications: UserNotificationInterface[] = []
  title = 'soko-console-web-v2';
  offeringPageSections = new Map<string, PageSection[]>();
  offeringPageSectionItems = new Map<string, PageSectionItem[]>();

  constructor(private matIconRegistry: MatIconRegistry,
              private domSanitizer: DomSanitizer,
              private matDialog: MatDialog,
              private themeService: ThemeService,
              private tabManagementService: TabManagementService,
              private location: Location,
              private contextService: ConsoleContextService,
              private landlordService: LandlordsService,
              private authorizationService: ConsoleAuthorizationService,
              private utilService: UtilsService,
              private userService: ConsoleUserService,
              private loader: LoadingService,
              private navUtils: NavigationUtilsService,
              private route: ActivatedRoute,
              private router: Router) {

    this.matIconRegistry.addSvgIcon('back-arrow-button', this.domSanitizer.bypassSecurityTrustResourceUrl('../assets/icons/back-arrow-button.svg'));
    this.tabManagementService.getPageAddEvent()
      .subscribe((pageToAdd: PageItemModel) => {
        this.pages.push(pageToAdd)
      });

    this.tabManagementService.getCloseAllTabsEvent()
      .subscribe(() => {
        this.pages = [];
      });

    this.tabManagementService.getCloseOthersTabsEvent()
      .subscribe((pageToKeep: PageItemModel | null) => {
        this.pages = [];
        if (pageToKeep) {
          this.pages.push(pageToKeep);
        }
      });

    this.tabManagementService.getLandlordChangeEvent()
      .subscribe(($event: MatSelectChange) => {
        this.isPropertySelected = false;
        this.selectedProperty = null;
        const landlordId = $event.value
        this.contextService.setCurrentWebClient(landlordId)
          .then((response: CurrentLandlordModel | null) => {
            if (response == null) {
              this.navUtils.navigateWithQueryParams('/404');
            } else {
              this.landlord = response!;
              this.landlordLogo = this.landlord.companyLogo ? this.landlord.companyLogo : '../assets/icons/default-logo.svg';
              this.location.replaceState(`${this.landlord.code}`);
              this.resetLandlordPropertiesSelection(landlordId);
              this.themeService.setThemeColors(response ? response.theme : null);
            }
          });
      });

    let landlordId: string = this.contextService.getCurrentLandlordId()!;
    this.resetLandlordPropertiesSelection(landlordId);
    if (this.contextService.getCurrentLocation() != null) {
      this.changeSelectedProperty(this.contextService.getCurrentLocation()!);
    }
    //todo: check if the tokens are already set in storage if they aren't then make the requests
    this.contextService.getCurrentWebClient()
      .then((result: CurrentLandlordModel | null) => {
        this.landlord = result!;
        this.landlordLogo = this.landlord.companyLogo ? this.landlord.companyLogo : '../assets/icons/default-logo.svg';
        this.themeService.setThemeColors(result ? result.theme : null);
      });

    this.tabManagementService.getTabChangeEvent().subscribe(($event) => {
      this.setFocusedOffering($event.pageInFocus);
    });
  }

  get getDate(): any {
    return new Date();
  }

  ngOnInit(): void {
    if (this.selectedProperty != null) {
      this.initPageOfferingsAndSections(false);
    }
  }

  shouldDoRedirect() {
    return this.route.snapshot.url.length > 0 && this.route.snapshot.data['openTab'];
  }

  ngAfterViewInit() {
  }

  openSpecificPage() {
    const MAIN_SECTION: PageSectionItemInfo[] = leasingItems;
    const SECTION_CODE: string = 'leasing';
    const ITEM_CODE: string = 'lease-bookings';
    const OFFERING_UUID = '42cb6a58-d268-ee11-9935-0022486647d1';

    const section = this.getPageSections(OFFERING_UUID)
      .find(f => f.code == SECTION_CODE);

    const initialItemInfo = MAIN_SECTION
      .find(f => f.pageCode == ITEM_CODE);

    if (initialItemInfo && section) {
      const tab = PageSectionItem.fromPageSectionItemInfo(initialItemInfo, section);
      if (tab) this.openPageSectionTab(tab);
    }
  }

  resetLandlordPropertiesSelection(landlordId: string) {
    lastValueFrom(this.userService.getAllowedLocationsForLandlord(landlordId))
      .then((result: string[]) => {
        this.contextService.setAllowedLocationsForLandlord(result);
        return Promise.resolve(result);
      })
      .then((allowedLocations: string[]) => {
        this.landlordService.getPropertiesForLandlord(landlordId)
          .then((result: LandlordPropertyModel[]) => {
            this.properties = result.filter(item => allowedLocations.includes(item.uuid));
            if (this.shouldDoRedirect()) {
              setTimeout(() => {
                const queryParams = {...this.route.snapshot.queryParams};
                const locationCode = queryParams['locationCode'];
                const property = this.properties.filter(f => equalsIgnoreCase(f.locationCode, locationCode))[0];
                this.changeSelectedProperty(property);
                return;
              }, 500)
            }
            if (this.properties.length == 1 && this.selectedProperty == null) {
              setTimeout(() => {
                this.changeSelectedProperty(this.properties.at(0)!);
              }, 500)
            }
          });
      });
  }

  supportPage(): void {
    const item = supportItem;
    let payload: PageEventInterface = {
      componentToRegister: item.componentToRegister,
      pageName: item.pageName,
      pageHeader: 'Customer Care',
      data: {
        properties: this.properties,
      },
      id: this.utilService.generateUuidWithPrefix(item.idPrefix),
      sectionCode: item.sectionCode,
      pageCode: item.pageCode,
    }
    this.tabManagementService.sendPageAddEvent(payload);
  }

  initPageOfferingsAndSections(checkOpenTab: boolean): void {
    this.pageOfferings = this.setPageOfferings();
    this.pageSections = this.setPageSections();
    this.pageSectionItems = this.setPageSectionItems();

    if (checkOpenTab) {
      if (this.route.snapshot.url.length > 0) {
        const queryParams = {...this.route.snapshot.queryParams};
        const clientId = this.route.snapshot.paramMap.get('clientId');

        this.router.navigate([`/${clientId}`], {
          replaceUrl: true
        }).then(() => {
          if (this.route.snapshot.data['openTab']) {
            this.openTabFromRedirect(queryParams);
          }
        });
      }
    }
  }

  openTabFromRedirect(params: any): void {
    const offeringCode = params['offeringCode'];
    const sectionCode = params['sectionCode'];
    const pageCode = params['pageCode'];
    const id = params['id'];
    const data = params['data'];

    this.pageOfferings.forEach(off => {
      if (equalsIgnoreCase(off.offeringCode, offeringCode)) {
        off.selected = true;
        this.getPageSections(off.uuid).forEach(sec => {
          if (equalsIgnoreCase(sec.code, sectionCode)) {
            sec.selected = true;
            const pageSection = sec;
            viewItems.forEach(item => {
              if (sec.code == item.sectionCode && equalsIgnoreCase(item.pageCode, pageCode)) {
                const pageItemInfo = item;

                if (pageSection && pageItemInfo) {
                  const pageSectionItem = new PageSectionItem(
                    pageItemInfo.idPrefix,
                    pageSection.uuid,
                    pageItemInfo.label,
                    pageItemInfo.componentToRegister,
                    pageItemInfo.pageName.replace(':id', this.utilService.displayUuid(id)),
                    pageSection.offering!.label,
                    {id: id, ...data},
                    pageSection.offeringUuid,
                    pageItemInfo.sectionCode,
                    pageItemInfo.pageCode,
                    pageItemInfo.openType,
                    pageItemInfo.featureCodes,
                    pageSection.offering
                  )
                  this.openPageSectionTab(pageSectionItem);
                }
              }
            })
          }
        })
      }
    });
  }

  setPageOfferings(): PageOffering[] {
    const resultSet: PageOffering[] = [];
    if (this.selectedProperty != null) {
      if (this.utilService.arrayNotEmptyFilter(this.selectedProperty.locationOfferings)) {
        this.selectedProperty.locationOfferings.forEach(
          offering => {
            resultSet.push(new PageOffering(offering.uuid, offering.offeringName, offering.offeringCode!, offering.platformOfferingType, offering.offeringUuid, offering.offeringAddress, offering.offeringStartDate, offering.tileImage, offering.bannerImage, offering.floorPlanImage, offering.offeringListing));
          }
        )
      }
    }
    return resultSet.sort((a, b) => a.label.localeCompare(b.label));
  }

  // todo change the function which checks each offering type to loop through the whole list and find the name of constant which matches the offering
  setPageSections(): PageSection[] {
    const sections: PageSection[] = [];
    this.pageOfferings.forEach(ea => {
      if (ea.offeringType === 'DISTRICT') {
        sections.push(...districtPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'GENERAL_LEASING') {
        sections.push(...generalLeasingPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'EXHIBITIONS') {
        sections.push(...exhibitionPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'STORAGE') {
        sections.push(...storagePageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'POP_UPS') {
        sections.push(...popUpsPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'DIGITAL_ADVERTISING') {
        sections.push(...digitalAdvertisingPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'MARKETS') {
        sections.push(...marketsPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'KIOSK') {
        sections.push(...kiosksPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }
      if (ea.offeringType === 'ON_DEMAND') {
        sections.push(...onDemandPageSections.map(m => new PageSection(this.utilService.generateUuidWithPrefix(''), ea.uuid, m.label, m.code, m.icon, ea)));
      }

    })
    this.setPageSectionsMap(sections);
    return sections;
  }

  setPageSectionItems(): PageSectionItem[] {
    let items: PageSectionItem[] = [];
    this.pageSections.forEach(pageSection => {
      const offeringName = pageSection.offering?.label!;
      switch (pageSection.code) {
        case 'leads':
          items.push(...pipelineItems.map(m =>
            PageSectionItem.fromPageSectionItemInfo(m, pageSection)
          ));
          break;
        case 'leasing':
          items.push(...leasingItems.map(m =>
            PageSectionItem.fromPageSectionItemInfo(m, pageSection)
          ));
          break;
        case 'settings':
          items.push(...settingsItems.map(m =>
            PageSectionItem.fromPageSectionItemInfo(m, pageSection)
          ));
          break;
        case 'accounts':
          items.push(...accountsItems.map(m =>
            PageSectionItem.fromPageSectionItemInfo(m, pageSection)
          ));
          break;
        case 'spaces':
          items.push(...spacesItems.map(m =>
            PageSectionItem.fromPageSectionItemInfo(m, pageSection)
          ));
          break;
        case 'dashboards':
          items.push(...dashboardItems.map(m => {
            return new PageSectionItem(m.idPrefix, pageSection.uuid, m.label, m.componentToRegister, m.pageName, offeringName, this.getLocationOfferingData(pageSection.offeringUuid), pageSection.offeringUuid, m.sectionCode, m.pageCode, m.openType, m.featureCodes, pageSection.offering)
          }));
          break;
        case 'on_demand':
          items.push(...onDemandItems.map(m =>
            PageSectionItem.fromPageSectionItemInfo(m, pageSection)
          ));
          break;
      }
    })
    items = items.filter(f => this.contextService.checkUserFeatures(f.featureCodes, f.offering!.offeringUuid));
    this.setPageSectionItemsMap(items);
    return items;
  }

  private getLocationOfferingData(offeringUuid: string): { offering: LocationOffering | null } {
    const offering = this.selectedProperty?.locationOfferings
      ?.find(offering => equalsIgnoreCase(offering.uuid, offeringUuid)) ?? null;
    return {offering: offering};
  }

  setPageSectionsMap(sections: PageSection[]) {
    this.offeringPageSections = sections.reduce((acc, section) => {
      if (acc.has(section.offeringUuid)) {
        acc.get(section.offeringUuid)!.push(section);
      } else {
        acc.set(section.offeringUuid, [section]);
      }
      return acc;
    }, new Map<string, PageSection[]>());
  }

  setPageSectionItemsMap(items: PageSectionItem[]) {
    this.offeringPageSectionItems = items.reduce((acc, item) => {
      if (acc.has(item.sectionUuid)) {
        acc.get(item.sectionUuid)!.push(item);
      } else {
        acc.set(item.sectionUuid, [item]);
      }
      return acc;
    }, new Map<string, PageSectionItem[]>());
  }

  getPageSections(offeringUuid: string): PageSection[] {
    return this.offeringPageSections.get(offeringUuid) ? this.offeringPageSections.get(offeringUuid)! : [];
  }

  getPageSectionItems(sectionUuid: string): PageSectionItem[] {
    return this.offeringPageSectionItems.get(sectionUuid) ? this.offeringPageSectionItems.get(sectionUuid)! : [];
  }

  togglePageSection(section: PageSection) {
    section.selected = !section.selected;
  }

  setFocusedOffering(pageInFocus: PageItemModel): void {
    if (pageInFocus) {
      this.pageOfferings.forEach(offering => {
        offering.selected = pageInFocus.offeringId === offering.uuid;
      })
      this.pageSections.forEach(section => {
        section.selected = (pageInFocus.sectionCode === section.code && pageInFocus.offeringId === section.offeringUuid);
      })
      this.pageSectionItems.forEach(item => {
        item.selected = pageInFocus.pageCode === item.pageCode && pageInFocus.offeringId === item.offeringId;
      })
    } else {
      this.pageSectionItems.forEach(item => {
        item.selected = false;
      })
    }
  }

  getNumberOfNotifications() {
    return this.notifications.length;
  }

  togglePageSectionItem(item: PageSectionItem) {
    item.selected = !item.selected;
  }


  openNotificationsDialog(): void {
    if (this.notificationSideNav.opened) {
      this.toggleNotifications(false);
    }

    let dialogRef = this.matDialog.open(NotificationsDialogComponent, {
      panelClass: 'dialog-medium',
      backdropClass: 'dialog-backdrop',
      position: {right: '130px', top: '70px'}
    })
    const openSidenav = dialogRef.componentInstance.openSidenav.subscribe(() => {
      this.notificationSideNav.open().then(() => dialogRef.close);
    })
    dialogRef.afterClosed().subscribe(() => openSidenav.unsubscribe());
  }

  toggleNotifications(switchView: boolean) {
    if (switchView) {
      this.notificationSideNav.close().then(() => this.openNotificationsDialog());
    } else {
      this.notificationSideNav.close();
    }
  }

  changeSelectedProperty($event: LandlordPropertyModel): void {
    this.tabManagementService.sendCloseAllTabsEvent();
    this.contextService.setCurrentLocation($event);
    this.isPropertySelected = true;
    this.selectedProperty = $event;
    this.authorizationService.refreshUserGrants().then(() => {
      setTimeout(() => {
        this.initPageOfferingsAndSections(true);
        // this.openSpecificPage();
      }, 500)
    });
  }

  openPageSectionTab(item: PageSectionItem): void {
    let payload: PageEventInterface = {
      componentToRegister: item.componentToRegister,
      pageName: item.pageName,
      pageHeader: item.pageHeader,
      data: item.data,
      id: this.utilService.generateUuidWithPrefix(item.id),
      offeringId: item.offeringId,
      sectionCode: item.sectionCode,
      pageCode: item.pageCode,
      offering: item.offering
    }
    this.tabManagementService.sendPageAddEvent(payload);
  }

  openPageSectionDialog(item: PageSectionItem): void {
    this.contextService.setCurrentOfferingId(item.offering!.offeringUuid);
    this.matDialog.open(item.componentToRegister, {
      panelClass: item.panelClass ? item.panelClass : 'dialog-large',
      data: {
        ...item.data,
        offering: item.offering
      }
    })
  }

  openGlobalSettings() {
    let payload: PageEventInterface = {
      componentToRegister: GlobalSettingsComponent,
      pageName: 'Global Settings',
      pageHeader: this.landlord.companyName,
      data: [],
      id: this.utilService.generateUuidWithPrefix('settings')
    }
    this.tabManagementService.sendPageAddEvent(payload);
  }

  toggleSidenav() {
    if (this.selectedProperty != null) {
      this.sidenav.toggle();
    }
  }

  changeSelectedPropertyFromNavConfirm($event: MatSelectChange) {
    const element: HTMLElement = $event.source._elementRef.nativeElement;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      message: 'Changing the selected property will close all open tabs. Are you sure you want to continue?',
      buttonConfirmLabel: 'OK',
      buttonCancelLabel: 'Cancel'
    };
    dialogConfig.position = {
      top: element.offsetTop + (element.offsetHeight * 2) + 'px',
      left: element.offsetLeft + element.offsetWidth + 'px'
    };
    const dialogRef = this.matDialog.open(ConfirmationDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.changeSelectedPropertyFromNav($event);
      } else {
        $event.source.value = this.selectedProperty?.uuid;
      }
    });
  }

  changeSelectedPropertyFromNav($event: MatSelectChange) {
    const uuid = $event.value;
    let landlordPropertyModel = this.properties.find(property => property.uuid === uuid);
    if (landlordPropertyModel !== null && landlordPropertyModel !== undefined) {
      this.changeSelectedProperty(landlordPropertyModel!);
    } else {
      console.log("error changing properties");
    }
  }

  pageSectionsIsEmpty(offeringUuid: string): boolean {
    let pageSectionItems = this.getPageSections(offeringUuid)
      .map(section => this.getPageSectionItems(section.uuid))
      .reduce((acc, val) => acc.concat(val), []);
    return pageSectionItems.length === 0;
  }

  public updateOffering(updatedOffering: LocationOffering) {
    this.selectedProperty?.locationOfferings?.forEach((offering: LocationOffering) => {
      if (offering.uuid === updatedOffering.uuid) {
        offering = updatedOffering;
      }
    });

    const index = this.pageOfferings.findIndex(el => updatedOffering.uuid === el.uuid);
    if (index !== -1) {
      this.pageOfferings[index].floorPlanImage = updatedOffering.floorPlanImage;
    }
  }
}
